export const GOOGLE_TRANSLATE_CLASSES = {
  // Checking the that google translated related classes are present
  // which would indicate that google translate is in use.
  // Note that translated-ltr means text translated to a language that is left to right,
  // whereas translated-rtl means text translated to a language that is right to left
  ltr: 'translated-ltr',
  rtl: 'translated-rtl',
}
export const isGoogleTranslateEnabled = () => {
  return (
    document.documentElement.classList.contains(GOOGLE_TRANSLATE_CLASSES.ltr) ||
    document.documentElement.classList.contains(GOOGLE_TRANSLATE_CLASSES.rtl)
  )
}
